import { SheetClose, SheetFooter, SheetHeader } from '@eliadmin/core/src/components/ui/sheet';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { buildToursSearchParams, useTourStore } from '@eliadmin/core/src/stores/tours-store';
import { TourSidebarFilterDates } from './tour-sidebar-filter-fields/tour-sidebar-filter-dates';
import { TourSidebarFilterGuests } from './tour-sidebar-filter-fields/tour-sidebar-filter-guests';
import { TourSidebarFilterNightsCount } from './tour-sidebar-filter-fields/tour-sidebar-filter-nights-count';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { TourSidebarFilterMaxPrice } from './tour-sidebar-filter-fields/tour-sidebar-filter-max-price';
import { TourSidebarFilterLocation } from './tour-sidebar-filter-fields/tour-sidebar-filter-location';
import { TourSidebarFilterEquipment } from './tour-sidebar-filter-fields/tour-sidebar-filter-equipment';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { IoClose } from 'react-icons/io5';
import { TourSidebarFilterTours } from './tour-sidebar-filter-fields/tour-sidebar-filter-tours';
import { usePathname, useRouter } from 'next/navigation';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const TourSidebarFilterContent = () => {
  const { t } = useTranslations();
  const { applyFilter, filter, clearFilters } = useTourStore();
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocaleStore(state => state.currentLocale);
  const toursRoute = ROUTES.TOURS(locale);

  const handleRedirectToTours = () => {
    if (pathname === toursRoute) {
      applyFilter(filter);
      return;
    }
    router.push(`${toursRoute}?${buildToursSearchParams({ ...filter, categories: [] })}`);
  };

  return (
    <>
      <SheetHeader className="fixed top-0 z-20 -ml-6 w-full bg-white px-6 pt-10">
        <h2 className="flex h-[52px] items-center pb-6 text-xl font-bold">{t('text174')}</h2>
        <Separator className="-ml-6 w-[600px]" />
      </SheetHeader>
      <div className="mt-[92px] flex flex-col gap-6 md:gap-8">
        <TourSidebarFilterTours />
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-4">
          <TourSidebarFilterDates />
          <TourSidebarFilterGuests />
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-4">
          <TourSidebarFilterNightsCount />
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-4">
          <TourSidebarFilterMaxPrice />
        </div>
        <Separator />
        <TourSidebarFilterLocation />
        <Separator />
        <TourSidebarFilterEquipment />
        <SheetFooter className="fixed bottom-0 z-20 flex max-w-[600px] flex-col bg-white pb-6">
          <div className="flex flex-col pr-6">
            <Separator className="-ml-6 w-[100vw] sm:w-[440px] md:w-[600px]" />
            <div className="flex flex-col-reverse gap-4 pr-6 pt-6 sm:flex-row">
              <Button
                onClick={() => {
                  clearFilters();
                  applyFilter({});
                }}
                className="min-h-[48px] flex-1 whitespace-nowrap rounded-md bg-[#F6F6F6] !text-primary hover:bg-[#F1F1F1] md:h-14"
                asChild
              >
                <SheetClose>
                  <IoClose className="mr-2 h-5 w-5" />
                  {t('text244')}
                </SheetClose>
              </Button>
              <Button
                asChild
                className="min-h-[48px] flex-1 whitespace-nowrap rounded-md md:h-[52px]"
                onClick={() => {
                  if (filter.tour) {
                    handleRedirectToTours();
                  } else {
                    applyFilter(filter);
                  }
                }}
              >
                <SheetClose>{t('text1380')}</SheetClose>
              </Button>
            </div>
          </div>
        </SheetFooter>
      </div>
    </>
  );
};
